<script lang="ts">
    import { VpArrowUpDownIcon } from '@decathlon-experience/icons/svelte';
    import { onMount, onDestroy } from 'svelte';

    import { sortingEntries } from '$saga/views/Search/constants';

    export let sortRef: HTMLInputElement | null = null;

    let selectRefMobile: HTMLSelectElement | null = null;
    let selectRefDesktop: HTMLSelectElement | null = null;

    const updateSort = (event: Event) => {
        if (sortRef && event.currentTarget) {
            sortRef.value = event.currentTarget?.value;
            sortRef.dispatchEvent(new Event('change'));
        }
    };

    onMount(() => {
        selectRefMobile?.addEventListener('change', updateSort);
        selectRefDesktop?.addEventListener('change', updateSort);
    });

    onDestroy(() => {
        selectRefMobile?.removeEventListener('change', updateSort);
        selectRefDesktop?.removeEventListener('change', updateSort);
    });
</script>

<div class="hidden items-center justify-center gap-xs desktop:flex">
    <VpArrowUpDownIcon size={16} class="text-content-brand" />
    <span class="hidden text-sm text-content-brand desktop:inline"
        >Trier par :</span
    >
    <select
        bind:this={selectRefDesktop}
        class="m-0 h-auto w-auto !border-none !bg-transparent !bg-none p-0
         text-sm text-content-brand shadow-none !outline-none focus:!bg-none focus:!shadow-none focus:!outline-none focus:ring-0"
    >
        {#each sortingEntries as sortingEntry}
            <option
                value={sortingEntry.value}
                selected={sortingEntry.value === sortRef?.value}
                class="px-s py-xs"
            >
                {sortingEntry.label}
            </option>
        {/each}
    </select>
</div>

<select
    bind:this={selectRefMobile}
    class="w-full text-ellipsis whitespace-nowrap rounded-full border border-solid border-border-neutral bg-white p-l px-l py-s text-xs shadow-none
    !outline-none focus:!shadow-none focus:!outline-none focus:ring-0 medium:w-fit desktop:hidden"
>
    {#each sortingEntries as sortingEntry}
        <option
            value={sortingEntry.value}
            selected={sortingEntry.value === sortRef?.value}
            class="p-xs"
        >
            {sortingEntry.label}
        </option>
    {/each}
</select>
